export const LAWYER_ROLE = 'lawyer'
export const LAWYER_WORKBENCH_PATH = '/lawyer'
export const LAWYER_CERT_PATH = '/lawyer/cert'
export const USER_DEFAULT_PATH = '/u/ai-doc'
export const LAWYER_CERT_STATUS_PATH = '/client/legal/lawyer/application/status'
export const LAWYER_CERT_DETAIL_PATH = '/client/legal/lawyer/application/detail'
export const LAWYER_CERT_APPLY_PATH = '/client/legal/lawyer/application/apply'
export const LAWYER_CERT_UPLOAD_PATH = '/client/legal/lawyer/application/upload'

export type LawyerCertificationView = 'form' | 'auditing' | 'approved' | 'rejected' | 'disabled'

export function hasLawyerRole(roles: readonly string[]): boolean {
  return roles.includes(LAWYER_ROLE)
}

export function getLawyerEntryPath(roles: readonly string[]): string {
  return hasLawyerRole(roles) ? LAWYER_WORKBENCH_PATH : LAWYER_CERT_PATH
}

export function getMissingRoleRedirectPath(role: string): string {
  return role === LAWYER_ROLE ? LAWYER_CERT_PATH : USER_DEFAULT_PATH
}

export function resolveLawyerCertificationView({
  isLawyer = false,
  status,
}: {
  isLawyer?: boolean
  status?: string | number | null
}): LawyerCertificationView {
  if (isLawyer) return 'approved'

  switch (String(status ?? '')) {
    case '1':
      return 'auditing'
    case '2':
      return 'approved'
    case '3':
      return 'rejected'
    case '4':
      return 'disabled'
    default:
      return 'form'
  }
}

export function getLawyerCertificationStatusLabel({
  isLawyer = false,
  status,
  isLoading = false,
}: {
  isLawyer?: boolean
  status?: string | number | null
  isLoading?: boolean
}): string {
  if (isLawyer) return '已认证'
  if (isLoading) return '查询中'

  switch (String(status ?? '')) {
    case '1':
      return '审核中'
    case '2':
      return '已认证'
    case '3':
      return '需修改'
    case '4':
      return '已禁用'
    default:
      return '去认证'
  }
}
